/**
 * Packages — show view. The unified store renders through the one shared
 * Inspector grammar (`PackageInspectorShow`): Header (compile · advance
 * maturity · Edit/Delete menu) / Overview (with skill- and contour-typed
 * columns) / Body / Relations (package links) / Audit. `packages` is a real
 * Refine resource, so no facade overrides are needed.
 */
import { PackageInspectorShow } from "./PackageInspectorShow";

export function PackageShow() {
  return (
    <PackageInspectorShow
      resource="packages"
      label="Package"
      subtitle="A package in the unified store — skills, contours, bets, frames, and principles."
    />
  );
}

export default PackageShow;
